import React from 'react';

const RatingInfo = () => {
  return (
    <div>
 <p className='font-bebas text-[32px] text-[#1A1A1A] py-6'> User Level & Rating System</p>
    </div>
  );
};

export default RatingInfo;